<div *ngIf="!loading">
<table *ngIf="fact" class="table">
  <tbody>
    <tr>
        <td>Body</td>
        <td>
            <a [routerLink]="['/admin/fact/edit',fact.server_fact_id]">
               {{fact.body}}
            </a>
        </td>
    </tr>
    <tr>
        <td>Explanation</td>
        <td>{{fact.explanation}}</td>
    </tr>
    <tr>
        <td>Description</td>
        <td>{{fact.description}}</td>
    </tr>

  </tbody>
</table>
<div *ngIf="subTopics" >
  <h6 class ="background-primary"> Sub Topics</h6>
  <table  class="table table-striped">
    <thead>
      <tr>
        <td>id</td>
        <td>name</td>
        <td>syllabus Code</td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let factTopic of subTopics;">
        <td>{{factTopic.id}}</td>
        <td>{{factTopic.name}}</td>
        <td>{{factTopic.syllabusCode}}</td>

    </tr>
    </tbody>

  </table>
</div>

<div *ngIf="currentHoaxList">

<h6 class="background-primary">Hoax</h6>
<table  class="table table-striped">
  <thead>
    <tr>
      <td>body</td>
      <td>explanation</td>
      <td>Description</td>
      <td></td>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let hoax of currentHoaxList;">
      <td>{{hoax['body']}}</td>
      <td>{{hoax['explanation']}}</td>
      <td>{{hoax['description']}}</td>
      <td><button (click)="removeHoax(hoax['id'])" class="btn btn-primary"> Remove</button></td>
  </tr>
  </tbody>

</table>
</div>


<span [appMath]="''"></span>
<div class="alert alert-info" *ngIf="!fact"> Item Not Found</div>
</div>
<app-spinner *ngIf="loading"></app-spinner>
<div class="text-center">
    <a [routerLink]="['/admin/fact/index']" class="btn btn-primary me-2"><i class="fa fa-list"></i> List</a>
     <button (click)="testFact()" class='btn btn-primary me-2'>Test Fact</button>
    <a *ngIf="fact" [routerLink]="['/admin/fact/edit',fact.server_fact_id]" class="btn btn-primary me-2"><i class="fa fa-edit"></i> Edit</a>
    <a *ngIf="fact" [routerLink]="['/fact/template/update',fact.server_fact_id]" class="btn btn-primary me-2"><i class="fa fa-edit"></i> Update Template</a>
    <button *ngIf="fact" (click)="duplicateFactBook()" class="btn btn-primary"><i class="fa fa-edit"></i> Duplicate</button>
    <a *ngIf="fact" [routerLink]="['/admin/add/hoax/to/fact/',0,fact.server_fact_id]" class="btn btn-primary m-2"><i class="fa fa-add"></i> Add Hoax</a>

</div>





